import React, { useState, useEffect } from 'react';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { FormikProps } from 'formik';
import { FormikTextField } from '../../../shared/Formik/FormikTextField';
import { Preview } from '../../../components/dialogs/Prewiew';
import { BannerWrapper, StyledField, Label } from '../../CreateCampign.styles';
import { getBannerText, ContentFields } from './utils';
import { PreviewWrapper } from './Content.styles';

export const Content = (props: FormikProps<any>) => {
  const [showPreview, setShowPreview] = useState(false);
  const [previewLock, setPreviewLock] = useState(true);
  const { adType } = props.values.basicInformation;
  const publicUrl = sessionStorage.getItem('publicUrl')
  const getCampaignType = (type: string) => {
    switch (type) {
      case 'S':
        return 'medium rectangle';
      case 'B':
        return `leaderboard`;
      case 'V':
        return 'video ';
      default:
        return 'poll ';
    }
  }
  const getCampaignTypePreview = (type: string) => {
    switch (type) {
      case 'S':
        return 'Small banner';
      case 'B':
        return `Big banner`;
      case 'V':
        return 'Video';
      case 'P':
        return 'Poll';
      default:
        return '';
    }
  }

  const previewValidation = () => {
    const campaignData = props.values.content;
    if (!campaignData.mediaFile || !campaignData.mobileFile || !campaignData.desktopFile) {
      setPreviewLock(true);
    }
    switch (adType) {
      case 'S':
        if (props.values.content.mediaFile) {
          setPreviewLock(false)
        }
        break;
      case 'B':
        if (props.values.content.mobileFile && props.values.content.desktopFile) {
          setPreviewLock(false)
        }
        break;
      case 'V':
        if (props.values.content.mediaFile) {
          setPreviewLock(false)
        }
        break;
      case 'P':
        if (props.values.content.mediaFile 
          && props.values.content.poll.question 
          && props.values.content.poll.choices.length > 1 
          && props.values.content.poll.choices[1] !== ""
          && props.values.content.poll.postVotingMessage) {
          setPreviewLock(false)
        }
        break;
      default:
        return null;
    }
  }
  useEffect(() => {
    previewValidation();
  }, [props.values.content])
  const linkGenerator = (path: string) => {
    if (path) {
      return path.includes('http') ? path : `${sessionStorage.getItem('publicUrl')}/${path}`
    }
    else {
      return;
    }
  }
  return (
    <>
      {adType !== 'V' &&
        <BannerWrapper>
          {getBannerText(adType)}
          You don’t have a banner? <a href="mailto:shaun@dovemed.com">Click here</a>
        </BannerWrapper>
      }
      <ContentFields type={adType} />
      <Label>Redirect Link</Label>
      <StyledField
        name="content.redirectLink"
        variant="outlined"
        placeholder="https://www.example.com"
        fullWidth
        component={FormikTextField}
      />
      <PreviewWrapper onClick={() => {
        previewValidation();
        if (!previewLock) {
          setShowPreview(true);
        }
      }}>
        {previewLock ? <VisibilityOff /> : <Visibility />}
        Preview your {getCampaignType(adType)}
      </PreviewWrapper>
      <Preview 
        open={showPreview}
        setOpen={setShowPreview}
        adType={getCampaignTypePreview(adType)}
        image={linkGenerator(props.values.content.mediaFile) || linkGenerator(props.values.content.desktopFile)}
        imageMobile={linkGenerator(props.values.content.mobileFile)}
        video={linkGenerator(props.values.content.mediaFile)}
        pollCreate={props.values.content.poll}
      />
    </>
  )
};
